import React from 'react';

const defaultTheme = {
  accentColor: '#007AFF',
  backgroundColor: '#FFFFFF',
  textColor: '#000000',
  textSecondary: '#666666',
  borderColor: '#E5E5E5',
  cardBackground: '#F9F9F9',
  logoUrl: null,
  companyName: 'Inspection Butler'
};

const ThemeContext = React.createContext(defaultTheme);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = React.useState(() => {
    const saved = localStorage.getItem('ib-theme');
    return saved ? { ...defaultTheme, ...JSON.parse(saved) } : defaultTheme;
  });

  const updateTheme = (updates) => {
    const newTheme = { ...theme, ...updates };
    setTheme(newTheme);
    localStorage.setItem('ib-theme', JSON.stringify(newTheme));
  };

  const resetTheme = () => {
    setTheme(defaultTheme);
    localStorage.removeItem('ib-theme');
  };

  return (
    <ThemeContext.Provider value={{ theme, updateTheme, resetTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return React.useContext(ThemeContext);
}

export { ThemeContext, defaultTheme };
